import { component } from "picoapp";

export default component((node) => {
  if (!node) return;
  node.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth",
    });
  });
});
